<template>
  <div id="customer">
    <div v-if="isActive" class="grid-wrap">
      <kendo-grid ref="grid"
                  :auth="true"
                  :options="tableOptions"
                  :columns="tableFields"
                  :dataUrl="dataUrl + '/biz/solarhome/customer/'"
                  :size="'k-grid-md'"
                  :message="'등록된 고객이 없습니다.'"
                  :filename="title + '목록'"
                  :dblClickRow="openEdit"></kendo-grid>
    </div>
    <sidebar-detail v-if="user.lease_installer_id"
                    ref="sidebarDetail"
                    :active="sideActive"
                    :loader="sideLoaderActive"
                    :title="'고객정보'"
                    :tabList="tabList"
                    :staticList="staticList"
                    :notification="notificationList"
                    :formClass="'form-all'"
                    :fields="editFields"
                    :footerFields="footerFields"
                    @closeNotification="closeNotification"
                    @submitRecord="editCustomer"
                    @close="closeEdit"
                    @getRequired="getRequired"
                    v-model="customerData"></sidebar-detail>
    <!-- 신규등록 버튼  -->
    <div v-if="user.lease_installer_id"
         role="button"
         class="fab"
         aria-label="고객신규등록"
         aria-tooltip="고객신규등록"
         @click.prevent="addCustomer">
      <img src="../../assets/svg/ic-plus-white.svg" class="icon">
    </div>
    <!-- 접속한 유저가 등록된 시공사가 아닐 경우 문구출력 -->
    <p v-if="!user.lease_installer_id" class="page-none-text">등록된 시공사가 아닙니다.</p>
    <!-- 신규고객 등록창 -->
    <add-customer ref="customerModal" @refresh="$refs.grid.refresh()"></add-customer>
  </div>
</template>

<script>
  import KendoGrid from 'common/components/KendoGrid'
  import SidebarDetail from 'common/components/SidebarDetail'
  import Modal from 'common/components/Modal'
  import AddCustomer from '@/components/AddCustomerModal'
  import api from '@/api/solarhome.js'
  import {mapActions, mapGetters} from 'vuex'

  export default {
    name: 'customer',
    components: {
      KendoGrid,
      SidebarDetail,
      Modal,
      AddCustomer
    },
    data: function () {
      return {
        title: '고객관리',
        isActive: false,
        sideActive: false,
        sideLoaderActive: false,
        tableOptions: {
          toolbar: ['excel'],
          pageable: {
            info: true,
            previousNext: true,
            numeric: true,
            pageSize: 100,
            pageSizes: [20, 50, 100, 'all'],
            refresh: true,
            buttonCount: 5,
            messages: {
              itemsPerPage: '페이지당 항목수'
            }
          }
        },
        tabList: [
          { id: 'basicInfo', name: '기본정보', selected: true },
          { id: 'siteInfo', name: '현장정보' },
          { id: 'fileInfo', name: '서류/정산' }
        ],
        staticList: [
          { title: '진행단계', id: 'biz_step__name' },
          { title: '영업구분', id: 'sales_type' },
          { title: '이름', id: 'name' },
          { title: '계약번호', id: 'contract_no' },
          { title: '연락처', id: 'contact' },
          { title: '지역', id: 'region' }
        ],
        tableFields: [
          {
            name: 'customer_info',
            text: '고객정보',
            type: 'split'
          },
          {
            name: 'name',
            text: '이름',
            class: 'col-6',
            type: 'text'
          },
          {
            name: 'contact',
            text: '연락처',
            class: 'col-6 margin-left-4',
            type: 'phone'
          },
          {
            name: 'contract_date',
            text: '계약일',
            class: 'col-6',
            type: 'date'
          },
          {
            name: 'nth_allocated',
            text: '배정차수',
            class: 'col-6 margin-left-4',
            type: 'text',
            readonly: 'readonly'
          },
          {
            name: 'credit',
            text: '신용도',
            class: 'col-6',
            type: 'text',
            readonly: 'readonly'
          },
          {
            name: 'contract_type',
            text: '분납여부',
            class: 'col-6 margin-left-4',
            type: 'text',
            readonly: 'readonly'
          },
          {
            name: 'address',
            text: '설치주소',
            type: 'address',
            detail: 'rest_address',
            defaultAddressType: 'new'
          },
          {
            name: 'register_info',
            text: '등록정보',
            type: 'split'
          },
          {
            name: 'created',
            text: '고객등록일',
            class: 'col-6',
            type: 'date',
            disabled: 'true'
          },
          {
            name: 'created',
            text: '고객등록일',
            class: 'col-6',
            type: 'date',
            disabled: 'true'
          }
        ],
        footerFields: [
          {
            name: 'select_step',
            type: 'select',
            label: '',
            options: [],
            class: 'col-xs-6',
            style: 'padding: 0 4px 0 0;',
            fieldClass: '',
            default: '',
            callback: 'getRequired'
          },
          {
            name: 'save',
            text: '저장',
            type: 'submit',
            class: 'col-xs-6',
            style: 'padding: 0 0 0 4px;',
            fieldClass: 'hz-btn-primary'
          }
        ],
        editFields: [],
        customerData: {},
        notificationList: [],
        fileUploadOption: {
          validation: {
            allowedExtensions: ['.pdf', '.jpg', '.jpeg', '.png'],
            maxFileSize: 5 * 1024 * 1024,
            minFileSize: 0
          }
        },
        dataUrl: location.protocol + '//' + location.hostname.replace('biz', 'api'),
        saveUrl: '/biz/solarhome_file/?section=lease&category=customer',
        removeUrl: '/biz/solarhome_file/delete/'
      }
    },
    watch: {
      'user': {
        handler: function () {
          this.setTableFields()
        },
        deep: true
      }
    },
    computed: {
      ...mapGetters({
        user: 'user'
      })
    },
    methods: {
      ...mapActions([
        'showToastMessage'
      ]),
      init: function () {
        const vm = this
        const query = vm.$route.query
        // 쿼리스트링 json 형태로 반환
        // const deparam = require('node-jquery-deparam')
        const deparam = require('jquery-deparam')

        // Url Query에 고객 필터가 있을 경우, 그리드에 필터 설정
        if (query && query.hasOwnProperty('filter')) {
          vm.tableOptions = deparam(query.filter)
        }

        // Url Query에 고객 ID가 있을 경우, Sidebar Open
        if (query && query.hasOwnProperty('id')) {
          vm.openEdit(query.id)
        }
      },
      setTableFields: function () {
        const vm = this
        // user에 시공사 id가 있을경우에만 render
        if (vm.user.lease_installer_id) {
          const installer = vm.user.lease_installer_id
          const option = {installer: installer}

          // kendo-grid url 요청시 parameter default setting
          vm.tableOptions.parameter = [ {name: 'installer', value: installer} ]
          vm.tableFields = [
            {field: 'business_year', title: '사업년도', type: 'string', filterable: {multi: true, search: true}, width: '100px'},
            {field: 'created', title: '해줌등록일', type: 'date', format: '{0:yyyy.MM.dd}', width: '120px'},
            {field: 'allocated_date', title: '신규배정일', type: 'date', format: '{0:yyyy.MM.dd}', width: '120px'},
            {field: 'biz_step__name', title: '진행단계', type: 'string', filterable: {multi: true, search: true}, width: '120px'},
            {field: 'sales_type', title: '영업구분', type: 'string', filterable: {multi: true, search: true}, width: '120px'},
            {field: 'contract_no', title: '계약번호', type: 'string', filterable: {multi: true, search: true}, fieldOption: option, width: '130px'},
            {field: 'contract_date', title: '계약일', type: 'date', format: '{0:yyyy.MM.dd}', width: '150px'},
            {field: 'name', title: '고객명', type: 'string', filterable: {multi: true, search: true}, fieldOption: option, width: '100px'},
            {
              field: 'region',
              title: '지역',
              type: 'string',
              filterable: {
                multi: true,
                search: true,
                itemTemplate: function (e) {
                  if (e.field === 'all') {
                    return '<li><label><input type="checkbox" name="' + e.field + '"/>#=' + e.field + '#</label></li>'
                  } else {
                    return '<li><label><input type="checkbox" name="' + e.field + '" value="#=region_code#"/>#=region#</label></li>'
                  }
                }
              },
              width: '80px'
            },
            {field: 'address', title: '설치주소', type: 'string', filterable: {multi: true, search: true}, fieldOption: option, width: '220px'},
            {field: 'contact', title: '연락처', type: 'string', filterable: {multi: true, search: true}, fieldOption: option, width: '160px'},
            {field: 'nth_allocated', title: '배정차수', type: 'string', format: '{0:##,#}차', width: '110px'},
            {field: 'is_calculated', title: '정산상태', type: 'string', template: "#= is_calculated == 'true' ? '예' : '아니오' #", width: '110px'},
            {field: 'install_location', title: '설치장소', type: 'string', filterable: {multi: true, search: true}, width: '150px'},
            {field: 'install_capacity', title: '설치용량', type: 'string', filterable: {multi: true, search: true}, width: '160px'},
            {field: 'contract_type', title: '분납구분', type: 'string', filterable: {multi: true, search: true}, width: '150px'}
          ]

          vm.isActive = true
        }
      },
      setEditFields: function () {
        const vm = this
        // 고객 정보
        const data = vm.customerData
        // API URL - 파일 업로드, 삭제 요청 URL
        const dataUrl = vm.dataUrl
        const saveUrl = dataUrl + vm.saveUrl
        const removeUrl = dataUrl + vm.removeUrl
        // 파일 업로드 옵션
        const fileUploadOption = vm.fileUploadOption

        vm.editFields = [
          {
            name: 'customer_info',
            text: '고객정보',
            type: 'split',
            tab: 'basicInfo',
            class: 'col-xs-12'
          },
          {
            name: 'name',
            text: '이름',
            type: 'text',
            tab: 'basicInfo',
            required: vm.checkRequired('name'),
            class: 'col-xs-6'
          },
          {
            name: 'contact',
            text: '연락처',
            type: 'phone',
            tab: 'basicInfo',
            required: vm.checkRequired('contact'),
            class: 'col-xs-6'
          },
          {
            name: 'contract_date',
            text: '계약일',
            type: 'date',
            tab: 'basicInfo',
            required: vm.checkRequired('contract_date'),
            class: 'col-xs-6'
          },
          {
            name: 'nth_allocated',
            text: '배정차수',
            type: 'text',
            readonly: 'readonly',
            tab: 'basicInfo',
            class: 'col-xs-6'
          },
          {
            name: 'credit',
            text: '신용도',
            type: 'text',
            readonly: 'readonly',
            tab: 'basicInfo',
            class: 'col-xs-6'
          },
          {
            name: 'contract_type',
            text: '분납여부',
            type: 'text',
            readonly: 'readonly',
            tab: 'basicInfo',
            class: 'col-xs-6'
          },
          {
            name: 'address',
            text: '설치주소',
            type: 'address',
            class: 'col-xs-12',
            style: 'margin-bottom: 4px;',
            fieldClass: 'input-address-md col-xs-12 padding-0',
            tab: 'basicInfo',
            required: vm.checkRequired('address'),
            valueChange: true,
            defaultAddressType: 'new'
          },
          {
            name: 'rest_address',
            type: 'text',
            class: 'col-xs-12',
            tab: 'basicInfo',
            placeholder: '상세주소를 입력해주세요.'
          },
          {
            name: 'register_info',
            text: '등록정보',
            type: 'split',
            tab: 'basicInfo',
            class: 'col-xs-12'
          },
          {
            name: 'created',
            text: '고객등록일',
            type: 'date',
            disabled: true,
            tab: 'basicInfo',
            required: vm.checkRequired('created'),
            class: 'col-xs-6'
          },
          {
            name: 'allocated_date',
            text: '신규배정일',
            type: 'date',
            disabled: true,
            tab: 'basicInfo',
            required: vm.checkRequired('allocated_date'),
            class: 'col-xs-6'
          },
          {
            name: 'sales_type',
            text: '영업구분',
            type: 'text',
            readonly: 'readonly',
            tab: 'basicInfo',
            required: vm.checkRequired('sales_type'),
            class: 'col-xs-6'
          },
          {
            name: 'copy_contract_owner',
            text: '계약서원본소유자',
            type: 'text',
            readonly: 'readonly',
            required: vm.checkRequired('copy_contract_owner'),
            tab: 'basicInfo',
            class: 'col-xs-6'
          },
          {
            name: 'installer_memo',
            text: '시공사메모',
            type: 'textarea',
            placeholder: '고객의 특이사항 등 기억하거나 함께 일하는 분들에게 공유할 정보를 자유롭게 작성해주세요.',
            tab: 'basicInfo',
            class: 'col-xs-12'
          },
          {
            name: 'hz_memo',
            text: '해줌메모',
            type: 'textarea',
            readonly: 'readonly',
            tab: 'basicInfo',
            class: 'col-xs-12'
          },
          {
            name: 'installment_info',
            text: '설비정보',
            tab: 'siteInfo',
            class: 'col-xs-12',
            type: 'split'
          },
          {
            name: 'module',
            text: '모듈',
            tab: 'siteInfo',
            required: vm.checkRequired('module'),
            class: 'col-xs-6',
            type: 'select',
            fields: {'text': 'name', 'value': 'id'},
            dataUrl: dataUrl + '/biz/product/module/?year=' + data.business_year
          },
          {
            name: 'inverter',
            text: '인버터',
            tab: 'siteInfo',
            required: vm.checkRequired('inverter'),
            class: 'col-xs-6',
            type: 'select',
            fields: {'text': 'name', 'value': 'id'},
            dataUrl: dataUrl + '/biz/product/inverter/?year=' + data.business_year
          },
          {
            name: 'house_type',
            text: '주택유형',
            tab: 'siteInfo',
            required: vm.checkRequired('house_type'),
            class: 'col-xs-6',
            type: 'select',
            label: '',
            options: [
              {name: '미정', value: null},
              {name: '목조', value: '목조'},
              {name: '철골', value: '철골'},
              {name: '조립식', value: '조립식'},
              {name: '기타', value: '기타'}
            ]
          },
          {
            name: 'install_location',
            text: '설치장소',
            tab: 'siteInfo',
            required: vm.checkRequired('install_location'),
            class: 'col-xs-6',
            type: 'select',
            label: '',
            options: [
              {name: '미정', value: null},
              {name: '마당형', value: '마당'},
              {name: '지붕형', value: '지붕'},
              {name: '주차장형', value: '주차장'},
              {name: '기타', value: '기타'}
            ]
          },
          {
            name: 'install_capacity',
            text: '설치용량',
            tab: 'siteInfo',
            required: vm.checkRequired('install_capacity'),
            class: 'col-xs-6',
            type: 'select',
            label: '',
            options: [
              {name: '미정', value: 0},
              {name: '3kWp', value: 3},
              {name: '5kWp', value: 5},
              {name: '6kWp', value: 6}
            ]
          },
          {
            name: 'site_examined_info',
            text: '현장검토',
            tab: 'siteInfo',
            class: 'col-xs-12',
            type: 'split'
          },
          {
            name: 'check_spot_start_date',
            text: '검토예정일(시작)',
            tab: 'siteInfo',
            required: vm.checkRequired('check_spot_start_date'),
            class: 'col-xs-6',
            type: 'date'
          },
          {
            name: 'check_spot_end_date',
            text: '검토예정일(종료)',
            tab: 'siteInfo',
            required: vm.checkRequired('check_spot_end_date'),
            class: 'col-xs-6',
            type: 'date'
          },
          {
            name: 'check_spot_date',
            text: '검토완료일',
            tab: 'siteInfo',
            required: vm.checkRequired('check_spot_date'),
            class: 'col-xs-6',
            type: 'date',
            popOver: '검토가 완료된 후 입력해주세요.',
            next: false,
            related: 'state_check'
          },
          {
            name: 'state_check',
            text: '검토상태',
            tab: 'siteInfo',
            required: vm.checkRequired('state_check'),
            class: 'col-xs-6',
            type: 'text',
            readonly: 'readonly',
            template: '#= check_spot_date !== null?"완료":"미완료"#',
            default: data.check_spot_date ? '완료' : '미완료'
          },
          {
            name: 'construction_info',
            text: '시공진행',
            tab: 'siteInfo',
            type: 'split',
            class: 'col-xs-12'
          },
          {
            name: 'install_start_date',
            text: '시공예정일(시작)',
            tab: 'siteInfo',
            required: vm.checkRequired('install_start_date'),
            class: 'col-xs-6',
            type: 'date'
          },
          {
            name: 'install_end_date',
            text: '시공예정일(종료)',
            tab: 'siteInfo',
            required: vm.checkRequired('install_end_date'),
            class: 'col-xs-6',
            type: 'date'
          },
          {
            name: 'completion_date',
            text: '시공완료일',
            tab: 'siteInfo',
            required: vm.checkRequired('completion_date'),
            class: 'col-xs-6',
            type: 'date',
            popOver: '시공 완료 후 입력해주세요.',
            next: false,
            related: 'stete_install'
          },
          {
            name: 'stete_install',
            text: '설비시공상태',
            tab: 'siteInfo',
            required: vm.checkRequired('stete_install'),
            class: 'col-xs-6',
            type: 'text',
            readonly: 'readonly',
            template: '#= completion_date !== null?"완료":"미완료"#',
            default: data.completion_date ? '완료' : '미완료'
          },
          {
            name: 'inspect_date',
            text: '사용전점검일',
            tab: 'siteInfo',
            required: vm.checkRequired('inspect_date'),
            class: 'col-xs-6',
            type: 'date',
            popOver: '사용전점검을 완료 후 입력해주세요.',
            next: false,
            related: 'state_inspect'
          },
          {
            name: 'state_inspect',
            text: '사용전점검신청상태',
            tab: 'siteInfo',
            required: vm.checkRequired('state_inspect'),
            class: 'col-xs-6',
            type: 'text',
            readonly: 'readonly',
            template: '#= inspect_date !== null?"완료":"미완료"#',
            default: data.inspect_date ? '완료' : '미완료'
          },
          {
            name: 'electric_completion_date',
            text: '전기시공완료일',
            required: vm.checkRequired('electric_completion_date'),
            tab: 'siteInfo',
            class: 'col-xs-6',
            type: 'date'
          },
          {
            name: 'required_files',
            text: '필수서류',
            tab: 'fileInfo',
            type: 'split',
            class: 'col-xs-12'
          },
          {
            name: 'copy_contract_new',
            text: '계약서사본',
            type: 'file',
            tab: 'fileInfo',
            required: vm.checkRequired('copy_contract'),
            permit: vm.checkFilePermit('copy_contract'),
            class: 'col-xs-12',
            autoUpload: true,
            auth: true,
            dataUrl: dataUrl,
            saveUrl: saveUrl,
            removeUrl: removeUrl,
            options: fileUploadOption
          },
          {
            name: 'photo_check_spot_new',
            text: '현장검토사진',
            type: 'file',
            tab: 'fileInfo',
            required: vm.checkRequired('photo_check_spot'),
            permit: vm.checkFilePermit('photo_check_spot'),
            class: 'col-xs-12',
            autoUpload: true,
            auth: true,
            dataUrl: dataUrl,
            saveUrl: saveUrl,
            removeUrl: removeUrl,
            options: fileUploadOption
          },
          {
            name: 'photo_inspect_new',
            text: '사용전점검확인증',
            type: 'file',
            tab: 'fileInfo',
            required: vm.checkRequired('photo_inspect'),
            permit: vm.checkFilePermit('photo_inspect'),
            class: 'col-xs-12',
            autoUpload: true,
            auth: true,
            dataUrl: dataUrl,
            saveUrl: saveUrl,
            removeUrl: removeUrl,
            options: fileUploadOption
          },
          {
            name: 'report_completion_new',
            text: '설치완료보고서',
            type: 'file',
            tab: 'fileInfo',
            required: vm.checkRequired('report_completion'),
            permit: vm.checkFilePermit('report_completion'),
            class: 'col-xs-12',
            autoUpload: true,
            auth: true,
            dataUrl: dataUrl,
            saveUrl: saveUrl,
            removeUrl: removeUrl,
            options: fileUploadOption
          },
          {
            name: 'serial_no_module_new',
            text: '모듈시리얼번호',
            type: 'file',
            tab: 'fileInfo',
            required: vm.checkRequired('serial_no_module'),
            permit: vm.checkFilePermit('serial_no_module'),
            class: 'col-xs-12',
            autoUpload: true,
            auth: true,
            dataUrl: dataUrl,
            saveUrl: saveUrl,
            removeUrl: removeUrl,
            options: fileUploadOption
          },
          {
            name: 'serial_no_inverter_new',
            text: '인버터시리얼번호',
            type: 'file',
            tab: 'fileInfo',
            required: vm.checkRequired('serial_no_inverter'),
            permit: vm.checkFilePermit('serial_no_inverter'),
            class: 'col-xs-12',
            autoUpload: true,
            auth: true,
            dataUrl: dataUrl,
            saveUrl: saveUrl,
            removeUrl: removeUrl,
            options: fileUploadOption
          },
          {
            name: 'copy_of_register_new',
            text: '건물등기부등본',
            type: 'file',
            tab: 'fileInfo',
            required: vm.checkRequired('copy_of_register'),
            permit: vm.checkFilePermit('copy_of_register'),
            class: 'col-xs-12',
            autoUpload: true,
            auth: true,
            dataUrl: dataUrl,
            saveUrl: saveUrl,
            removeUrl: removeUrl,
            options: fileUploadOption
          },
          {
            name: 'photo_module_new',
            text: '모듈전경사진',
            type: 'file',
            tab: 'fileInfo',
            required: vm.checkRequired('photo_module'),
            permit: vm.checkFilePermit('photo_module'),
            class: 'col-xs-12',
            autoUpload: true,
            auth: true,
            dataUrl: dataUrl,
            saveUrl: saveUrl,
            removeUrl: removeUrl,
            options: fileUploadOption
          },
          {
            name: 'photo_modem_meter_new',
            text: '모뎀/계량기사진',
            type: 'file',
            tab: 'fileInfo',
            required: vm.checkRequired('photo_modem_meter'),
            permit: vm.checkFilePermit('photo_modem_meter'),
            class: 'col-xs-12',
            autoUpload: true,
            auth: true,
            dataUrl: dataUrl,
            saveUrl: saveUrl,
            removeUrl: removeUrl,
            options: fileUploadOption
          },
          {
            name: 'photo_nameplate_new',
            text: '명판사진',
            type: 'file',
            tab: 'fileInfo',
            required: vm.checkRequired('photo_nameplate'),
            permit: vm.checkFilePermit('photo_nameplate'),
            class: 'col-xs-12',
            autoUpload: true,
            auth: true,
            dataUrl: dataUrl,
            saveUrl: saveUrl,
            removeUrl: removeUrl,
            options: fileUploadOption
          },
          {
            name: 'non_required_files',
            text: '필요시 제출 서류',
            type: 'split',
            tab: 'fileInfo',
            class: 'col-xs-12'
          },
          {
            name: 'copy_check_spot_new',
            text: '현장검토서',
            type: 'file',
            tab: 'fileInfo',
            required: vm.checkRequired('copy_check_spot'),
            permit: vm.checkFilePermit('copy_check_spot'),
            class: 'col-xs-12',
            autoUpload: true,
            auth: true,
            dataUrl: dataUrl,
            saveUrl: saveUrl,
            removeUrl: removeUrl,
            options: fileUploadOption
          },
          {
            name: 'electric_bill_new',
            text: '한전전기요금표',
            type: 'file',
            tab: 'fileInfo',
            required: vm.checkRequired('electric_bill'),
            permit: vm.checkFilePermit('electric_bill'),
            class: 'col-xs-12',
            autoUpload: true,
            auth: true,
            dataUrl: dataUrl,
            saveUrl: saveUrl,
            removeUrl: removeUrl,
            options: fileUploadOption
          },
          {
            name: 'copy_idcard_new',
            text: '신분증사본',
            type: 'file',
            tab: 'fileInfo',
            required: vm.checkRequired('copy_idcard'),
            permit: vm.checkFilePermit('copy_idcard'),
            class: 'col-xs-12',
            autoUpload: true,
            auth: true,
            dataUrl: dataUrl,
            saveUrl: saveUrl,
            removeUrl: removeUrl,
            options: fileUploadOption
          },
          {
            name: 'copy_account_new',
            text: '통장사본',
            type: 'file',
            tab: 'fileInfo',
            required: vm.checkRequired('copy_account'),
            permit: vm.checkFilePermit('copy_account'),
            class: 'col-xs-12',
            autoUpload: true,
            auth: true,
            dataUrl: dataUrl,
            saveUrl: saveUrl,
            removeUrl: removeUrl,
            options: fileUploadOption
          },
          {
            name: 'cable_module_state_new',
            text: '모듈 간선처리',
            type: 'file',
            tab: 'fileInfo',
            required: vm.checkRequired('cable_module_state'),
            permit: vm.checkFilePermit('cable_module_state'),
            class: 'col-xs-12',
            autoUpload: true,
            auth: true,
            dataUrl: dataUrl,
            saveUrl: saveUrl,
            removeUrl: removeUrl,
            options: fileUploadOption
          },
          {
            name: 'cable_circuit_breaker_state_new',
            text: '차단기 간선처리',
            type: 'file',
            tab: 'fileInfo',
            required: vm.checkRequired('cable_circuit_breaker_state'),
            permit: vm.checkFilePermit('cable_circuit_breaker_state'),
            class: 'col-xs-12',
            autoUpload: true,
            auth: true,
            dataUrl: dataUrl,
            saveUrl: saveUrl,
            removeUrl: removeUrl,
            options: fileUploadOption
          },
          {
            name: 'family_relation_new',
            text: '가족관계증명서',
            type: 'file',
            tab: 'fileInfo',
            required: vm.checkRequired('family_relation'),
            permit: vm.checkFilePermit('family_relation'),
            class: 'col-xs-12',
            autoUpload: true,
            auth: true,
            dataUrl: dataUrl,
            saveUrl: saveUrl,
            removeUrl: removeUrl,
            options: fileUploadOption
          },
          {
            name: 'file_etc_new',
            text: '기타1',
            type: 'file',
            tab: 'fileInfo',
            class: 'col-xs-12',
            autoUpload: true,
            auth: true,
            dataUrl: dataUrl,
            saveUrl: saveUrl,
            removeUrl: removeUrl,
            options: fileUploadOption
          },
          {
            name: 'file_etc2_new',
            text: '기타2',
            type: 'file',
            tab: 'fileInfo',
            class: 'col-xs-12',
            autoUpload: true,
            auth: true,
            dataUrl: dataUrl,
            saveUrl: saveUrl,
            removeUrl: removeUrl,
            options: fileUploadOption
          },
          {
            name: 'file_etc3_new',
            text: '기타3',
            type: 'file',
            tab: 'fileInfo',
            class: 'col-xs-12',
            autoUpload: true,
            auth: true,
            dataUrl: dataUrl,
            saveUrl: saveUrl,
            removeUrl: removeUrl,
            options: fileUploadOption
          }
        ]
      },
      setFooterFields: function () {
        const vm = this
        const data = vm.customerData
        const step = data.biz_step__name
        const avaliable = data.available_steps
        let stepList = [{name: step, value: step}]

        // 선택된 고객이 진행할 수 있는 단계목록을 만들어준다.
        for (let i in avaliable) {
          stepList.push({name: avaliable[i], value: avaliable[i]})
        }

        // 진행단계 항목 및 선택값을 초기화 해준다.
        vm.footerFields[0].options = stepList
        vm.footerFields[0].default = step
      },
      openEdit: function (id) {
        const vm = this

        // 사이드바 및 로더 활성화
        vm.sideActive = true
        vm.sideLoaderActive = true

        // 선택된 고객정보를 불러온다.
        vm.getCustomer(id)
      },
      closeEdit: function () {
        const vm = this
        // 사이드바 및 로더를 비활성화한다.
        vm.sideActive = false
        vm.sideLoaderActive = false
        // 탭 초기화
        vm.$refs.sidebarDetail.currentTab = 'basicInfo'
        // 유저정보 초기화
        vm.customerData = {}
        // 알림창 목록 초기화
        vm.notificationList = []
        // Url 초기화
        vm.$router.push({name: 'customer'})
      },
      getCustomer: function (id) {
        const vm = this

        // 선택된 고객정보를 불러온다.
        api.getCustomer(id, response => {
          if (response.error) {
            // API 호출 실패 시
            console.log('get Customer Error!', response)
          } else {
            // 진행단계 초기화
            response.select_step = response.biz_step__name
            // 현재 진행단계가 기본 설정이므로 필수항목을 초기화한다.
            response.next_required = []

            // 데이터 복사
            vm.customerData = $.extend(true, {}, response)
            // Url 초기화
            vm.$router.push({name: 'customer', query: {id: id}})

            // 필드 초기화 및 사이드바 로더 비활성화
            vm.$nextTick(function () {
              vm.setEditFields()
              vm.setFooterFields()
              vm.checkNotification(response.biz_step__name)
              vm.sideLoaderActive = false
            })
          }
        })
      },
      download: function () {
        // 다운로드 API 실행
        this.$refs.grid.download()
      },
      addCustomer: function () {
        // 신규고객 등록창을 띄운다.
        this.$refs.customerModal.show()
      },
      saveCustomer: function () {
        const vm = this
        // 파일 목록
        const fileArr = [
          'copy_contract_new',
          'additional_contract_new',
          'photo_check_spot_new',
          'photo_module_new',
          'photo_nameplate_new',
          'photo_modem_meter_new',
          'photo_inspect_new',
          'report_completion_new',
          'serial_no_module_new',
          'serial_no_inverter_new',
          'copy_idcard_new',
          'copy_account_new',
          'copy_of_register_new',
          'copy_check_spot_new',
          'electric_bill_new',
          'family_relation_new',
          'cable_state_new',
          'cable_circuit_breaker_state_new',
          'cable_module_state_new',
          'file_etc_new',
          'file_etc2_new',
          'file_etc3_new'
        ]
        let data = $.extend({}, true, vm.customerData)

        // 업르드된 파일정보에 ID 값만 담는다.
        for (let i in fileArr) {
          const name = fileArr[i]
          const file = data[name]
          // 파일이 있을 경우에만 실행
          if (file && file.length > 0) {
            data[name] = file[0].id
          } else {
            data[name] = null
          }
        }

        return new Promise((resolve, reject) => {
          api.saveCustomer(data, response => {
            if (response.error) {
              reject(response)
            } else {
              resolve(response)
            }
          })
        })
      },
      saveStep: function () {
        const data = this.customerData

        return new Promise((resolve, reject) => {
          api.saveStep(data, response => {
            if (response.error) {
              reject(response)
            } else {
              resolve(response)
            }
          })
        })
      },
      editCustomer: function (data) {
        const vm = this
        const isCancel = data.biz_step__name === '계약취소'

        if (isCancel) {
          // 진행단계가 계약취소 일 경우, 해줌 문의를 통해서만 상태 변경 가능
          alert('계약취소 고객은 해줌으로 문의주세요.')
        } else {
          const isValid = vm.requiredValidation()

          // 필수입력값이 모두 입력되었을 경우에만 실행
          if (!isValid) {
            alert('* 필수항목을 입력해주세요.')
          } else {
            const isChange = data.select_step !== data.biz_step__name
            if (isChange) {
              // 변경 취소 선택 시, 이벤트를 취소한다.
              if (confirm('선택된 진행단계로 변경하시겠습니까?')) {
                vm.saveCustomer().then(function () {
                  vm.saveStep().then(function () {
                    // 고객목록 업데이트
                    vm.$refs.grid.refresh()

                    // 사이드바를 닫는다.
                    vm.closeEdit()
                    vm.showToastMessage('고객정보 수정 완료')
                  }).catch(error => {
                    // API 호출 실패 시
                    console.log('edit Step fail!', error)
                    vm.showToastMessage('진행단계 수정 실패')
                  })
                }).catch(error => {
                  // API 호출 실패 시
                  console.log('edit Cusomter fail!', error)
                  vm.showToastMessage('고객정보 수정 실패')
                })
              }
            } else {
              // 고객정보 수정 API를 실행한다.
              vm.saveCustomer().then(function () {
                // 고객목록 업데이트
                vm.$refs.grid.refresh()

                // 사이드바를 닫는다.
                vm.closeEdit()
                vm.showToastMessage('고객정보 수정 완료')
              }).catch(error => {
                // API 호출 실패 시
                console.log('edit Cusomter fail!', error)
                vm.showToastMessage('고객정보 수정 실패')
              })
            }
          }
        }
      },
      requiredValidation: function () {
        // 필수입력값이 제대로 입력되었는지를 확인한다.
        const data = this.customerData
        const required = data.next_required
        let isValid = true

        // 선택된 진행단계로 넘어가기 위한 필수항목에 대한 유효성 검증을 한다.
        for (let i in required) {
          const field = required[i]
          // 데이터에 필드 데이터명이 있는경우에만 확인
          if (typeof data[field] !== 'undefined') {
            // 데이터에 값이 비었을 경우 False를 반환
            const d = data[field]
            if (!d || d === null) {
              isValid = false
            }
          } else if (typeof data[field + '_new'] !== 'undefined') {
            // _new가 붙을 경우 파일이므로 파일배열에 길이가 0보다 크지 않을 경우 False를 반환
            const d = data[field + '_new']
            if (d === null || d.length === 0) {
              isValid = false
            }
          }
        }

        // 필수항목 확인 상태를 반환한다.
        return isValid
      },
      getRequired: function (data) {
        if (data) {
          const vm = this
          // 현재 진행단계와 선택된 진행단계
          const step = {from: data.biz_step__name, to: data.select_step}

          // 선택된 진행단계에 필수항목을 불러온다.
          api.getRequired(step, response => {
            if (response.error) {
              // API 호출 실패 시
              console.log('get Required Error!', response)
            } else {
              // 진행단계 필수항목을 넣어준다.
              vm.customerData.next_required = response.fields
              // 수정창에 Fields를 재정의 해준다.
              vm.$nextTick(function () {
                vm.setEditFields()
              })
            }
          })
        }
      },
      checkRequired: function (id) {
        // 해당 필드가 필수항목에 속하는지 속하지 않는지를 구별하여 True,False 값을 반환한다.
        const data = this.customerData
        const required = data.next_required
        const isRequired = _.includes(required, id)

        // 필수 항목 여부 반환
        return isRequired
      },
      checkNotification: function (step) {
        // 고객의 진행단계에 따른 알림창을 생성한다.
        if (step) {
          const stateList = {
            '사용전점검완료': {id: '', state: 'info', message: '정산요청을 위해 서류를 등록해주세요.'},
            '계약취소': {id: '', state: 'warning', message: '계약취소 고객은 해줌으로 문의 해주세요.'},
            '서류부적합': {id: '', state: 'warning', message: '부적합 서류가 있습니다. 재등록해주세요.'},
            '서류통과': {id: '', state: 'success', message: '모든 서류가 통과되어 정산요청을 진행중입니다.'},
            '정산완료': {id: '', state: 'success', message: '모든 정산이 완료되었습니다.'}
          }
          const state = stateList[step]

          // 현재 진행단계가 해당 알림목록에 있을 경우에만 출력
          if (typeof state !== 'undefined') {
            if (this.notificationList.length === 0) {
              this.notificationList.push(state)
            }
          }
        }
      },
      closeNotification: function (index) {
        // 전달받은 배열의 인덱스를 찾아 지운다.
        this.notificationList.splice(index, 1)
      },
      checkFilePermit: function (id) {
        // 업로드 된 파일에 유효 상태를 구분하는 함수
        let state = ''
        const data = this.customerData

        // 고객 정보가 있을 경우에만 실행
        if (!_.isEmpty(data)) {
          // 부적합 파일 목록에서 해당 필드 ID 값이 있을 경우
          if (data.invalid_files.match(id)) {
            state = 'invalid'
          }
          // 적합 파일 목록에 해당 필드 ID 값이 있을 경우
          if (data.valid_files.match(id)) {
            state = 'valid'
          }
        }

        // 현재 파일 유효 상태에 대한 플래그를 반환한다.
        return state
      }
    },
    created: function () {
      const vm = this
      const token = localStorage.getItem('_t')

      // 사용자 인증 (토큰)
      if (token) {
        // 토큰 검증 및 갱신 성공 시 화면렌더 및 데이터 초기화.
        vm.$store.dispatch('inspectToken', token).then(() => {
          // 초기화
          vm.init()
          // 그리드 및 현재 페이지 설정
          vm.setTableFields()
        })
      } else {
        alert('로그인이 필요한 서비스 입니다. 로그인 화면으로 이동합니다.')
        vm.$router.push({name: 'login'})
      }
    },
    mounted: function () {
    },
    beforeDestroy: function () {
      // 켄도 라이브러리에 의해 생성된 찌꺼기 엘리먼트 초기화.
      kendo.destroy(document.body)
    }
  }
</script>

<style lang="scss">
  #customer {
    height: 100%;

    .grid-wrap {
      height: 100%;
      overflow: hidden;
    }

    .page-none {
      height: 100%;
      text-align: center;
      color: $font-color;
      font-weight: bold;
    }

    .fab {
      position: fixed;
      right: 32px;
      bottom: 32px;
      width: 56px;
      height: 56px;
      line-height: 54px;
      background-color: $primary-color-v2;
      border: none;
      border-radius: 28px;
      box-sizing: content-box;
      box-shadow: $z-depth-01;
      cursor: pointer;
      outline: none;
      overflow: hidden;
      text-align: center;
      z-index: 9;
      &:hover {
        background-color: darken($primary-color-v2, 10%);
      }
    }

    .page-none-text {
      position: absolute;
      top: 50%;
      width: 100%;
      text-align: center;
    }
  }

</style>



// WEBPACK FOOTER //
// src/pages/solarhome/Customer.vue